// Utility to remove emoji characters from strings.
// This uses a conservative regex to match most emoji and related pictographs.
// It intentionally preserves normal punctuation and letters.
export function stripEmoji(input: string): string {
	if (!input) return input

	// Convert to an array of user-perceived characters (handles surrogate pairs)
	const chars = Array.from(input)

	// Known emoji / pictograph ranges (covers common cases)
	const ranges: Array<[number, number]> = [
		[0x1f600, 0x1f64f], // emoticons
		[0x1f300, 0x1f5ff], // symbols & pictographs
		[0x1f680, 0x1f6ff], // transport & map
		[0x2600, 0x26ff], // misc symbols
		[0x2700, 0x27bf], // dingbats
		[0x1f900, 0x1f9ff], // supplemental symbols
		[0x1f1e6, 0x1f1ff], // flags
		[0x1fa70, 0x1faff], // extended
		[0xfe0f, 0xfe0f], // variation selector
	]

	function isEmojiChar(cp: number | undefined) {
		if (!cp) return false
		for (const [a, b] of ranges) {
			if (cp >= a && cp <= b) return true
		}
		return false
	}

	return chars
		.filter((ch) => {
			const cp = ch.codePointAt(0)
			return !isEmojiChar(cp)
		})
		.join('')
}
